module.exports = "/assets/images/loading.gif";


//////////////////
// WEBPACK FOOTER
// ./common/components/Loader/loading.gif
// module id = MB5U
// module chunks = 0